export enum DialogResults {
  Abort,
  Cancel,
  Confirm,
  Delete,
  Discard,
  Ignore,
  No,
  Ok,
  Retry,
  Yes,
  Stay,
  Logout,
  Send,
}
